import { Notation } from '@teetsh/app/src/types/notationSystem';
import _partition from '@teetsh/app/src/utils/arrays/partition';
import _last from 'lodash-es/last';
import _first from 'lodash-es/first';
import { ABS, NE } from 'containers/CarnetsDeNotes/constants';

export function getNotationFromValue(value: number, values: Notation[]) {
  if (value === NE.value) {
    return values[0]?.label ?? '';
  }
  if (value === ABS.value) {
    return values[1]?.label ?? '';
  }
  if (value === 0) {
    return values[2]?.label ?? '';
  }
  const positiveValues = values.filter(v => v.value >= 0);
  const [infValues, supValues] = _partition(
    positiveValues,
    v => v.value < value,
  );
  if (supValues.length === 0) {
    return _last(infValues)?.label ?? '';
  }
  if (infValues.length === 0) {
    return _first(supValues)?.label ?? '';
  }
  const lastInfValue = _last(infValues);
  const firstSupValue = _first(supValues);
  const diffWithLastInfValue = value - (lastInfValue?.value ?? 0);
  const diffWithFirstSupValue = (firstSupValue?.value ?? 0) - value;
  if (diffWithLastInfValue < diffWithFirstSupValue) {
    return lastInfValue?.label ?? '';
  }
  return firstSupValue?.label ?? '';
}
